export const css = {
	root: '_2LGVBEqp',
	content: '_15SrS74d',
	about: '_1KZWi_85',
	button: '_1L6W1QVB',
	remind: '_17tZQEVu',
	retake: 'ufecsU1S',
	bonusBlock: '_3So9Kd4N',
	bonusDescription: '_1km6S2ZP',
	bonus: '_2ECqdWG9',
	practiceExtra: '_305q_cXZ',
	scoreBlockTitle: '_11TbAG6T',
	lockIcon: '_3g_RKUdo',
	back: '_1jPTFxGN',
	disclaimer: '_3YxXCOjK',
	' _key': 'explore-view/practice-view'
};

export default css;
